import React, { useState } from 'react';
import { bool, number, string } from 'prop-types';
import Icon from 'yoda-core-components/lib/components/Icon';
import ImgNotAvailable from 'yoda-core-components/lib/assets/svg/NoImage.svg';
import classNames from 'classnames/bind';

const cx = classNames.bind();

const Image = ({ alt, iconSize, isSwatchSelected, swatchImageId }) => {
    const [isImageError, setIsImageError] = useState(false);

    return isImageError ? (
        <Icon className="text-gray-600" height={18} width={18}>
            <ImgNotAvailable />
        </Icon>
    ) : (
        <img
            alt={alt}
            className={cx('border-1 border-solid', {
                'border-gray-200': !isSwatchSelected,
                'border-white-100': isSwatchSelected,
            })}
            height={iconSize}
            onError={() => {
                setIsImageError(true);
            }}
            src={`//s7d1.scene7.com/is/image/JCPenney/${swatchImageId}?wid=${iconSize}&hei=${iconSize}&op_usm=.4,.8,0,0&resmode=sharp2`}
            width={iconSize}
        />
    );
};

Image.defaultProps = {
    alt: '',
    iconSize: 20,
    isSwatchSelected: false,
};

Image.propTypes = {
    swatchImageId: string.isRequired,
    alt: string,
    iconSize: number,
    isSwatchSelected: bool,
};

export default Image;
